<template>
  <div>
    <h3>Gegevens</h3>

    <div class="form-group">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">Naam</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <a-input name="name" type="text" v-model="nameValue"
                 :class="errorName.length > 0 && !nameValue ? 'has-error' : ''"/>
        <span v-if="errorName.length > 0" v-for="error in errorName" class="errors">
          {{ error }}
        </span>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">Kantooreigenaren</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <users-select v-model="ownerUserIds" fieldName="owners[]"></users-select>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">HTML e-mailtemplate</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <select-html-email-template-component field-name="html_email_template_id" v-model="htmlEmailTemplateIdValue"/>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">Kantoorcode</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <a-input name="code" type="text" v-model="codeValue"/>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">Regio(s)</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <region-select-component :selected-region-ids="regionsValue" field-name="regions[]"
                                 @change="setSelectedRegions"/>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">Telefoonnummer</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <a-input name="phone" type="text" v-model="phoneValue"/>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">E-mailadres</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <a-input name="email" type="text" v-model="emailValue"/>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">Website</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <a-input name="website" type="text" v-model="websiteValue"/>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">AFM-nummer</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <a-input name="afm_number" type="text" v-model="afmNumberValue"/>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">Kifid-nummer</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <a-input name="kifid_number" type="text" v-model="kifidNumberValue"/>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">Klantportaal link</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <a-input type="text" name="customer_portal_link" v-model="customerPortalLinkValue"/>
      </div>
    </div>

    <div class="form-group">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">Logo</label>
      <div v-bind:class="{ 'col-sm-7': horizontal}">
        <a-input type="file" name="logo"/>
      </div>
    </div>

    <h4>Producten uitsluiten</h4>
    <div>Producten die uitgesloten worden bij een vergelijking</div>

    <div class="form-group">
      <label class="control-label" v-bind:class="{ 'col-sm-4': horizontal}">Autoverzekering</label>
      <div v-if="!editingRollsProducts" v-bind:class="{ 'col-sm-7': horizontal}">
        <a-button @click="editingRollsProducts = true" v-if="!editingRollsProducts">Selecteer producten</a-button>
      </div>
      <div v-else v-bind:class="{ 'col-sm-7': horizontal}">
        <div>
          <a-select mode="tags" v-model="excludedRollsProducts">
            <a-select-option :key="product.id" :value="product.id" v-for="product in all_rolls_products">
              {{ product.name }}
            </a-select-option>
          </a-select>
        </div>
        <a-button v-if="editingRollsProducts" @click="selectAllRollsProducts">
          Geen producten uitsluiten
        </a-button>
      </div>
      <input type="hidden" :value="excludedRollsProducts"
             name="excluded_rolls_products">
    </div>

    <h3>Openingstijden</h3>

    <div v-if="errors.length > 0" v-for="error in errors" class="errors">
      {{ error }}
    </div>

    <edit-office-hours :days="days" :exception_values="exception_values" :holiday_values="holiday_values"
                       :holidays="holidays"></edit-office-hours>
  </div>
</template>


<script>
import EditOfficeHours from './EditOfficeHours'
import RegionSelectComponent from '../../region/components/RegionSelectComponent'

export default {
  name: 'OfficeComponent',
  components: {
    EditOfficeHours,
    RegionSelectComponent
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    html_email_template_id: {
      type: String,
      default: ''
    },
    ownerUserIds: {
      type: Array,
      default: () => ([])
    },
    code: {
      type: String,
      default: ''
    },
    selectedRegionIds: {
      type: Array,
      default: () => ([])
    },
    phone: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: ''
    },
    website: {
      type: String,
      default: ''
    },
    afm_number: {
      type: String,
      default: ''
    },
    kifid_number: {
      type: String,
      default: ''
    },
    excluded_rolls_products: {
      type: Array,
      required: false
    },
    customer_portal_link: {
      type: String,
      default: ''
    },
    horizontal: {
      type: Boolean,
      default: true
    },
    compare_defaults: {
      type: Object,
      default: null,
    },
    all_rolls_products: {
      type: Array,
      default: []
    },
    errors: {
      type: Array,
      default: () => ([]),
    },
    errorName: {
      type: Array,
      default: () => ([]),
    },
    days: {
      type: Object,
      default: () => ({}),
    },
    holidays: {
      type: Object,
      default: () => ({}),
    },
    holiday_values: {
      type: [Object, Array],
      default: () => ({}),
    },
    exception_values: {
      type: [Object, Array],
      default: () => ({}),
    },
  },
  data () {
    return {
      nameValue: this.name,
      htmlEmailTemplateIdValue: this.html_email_template_id,
      ownersValue: [],
      codeValue: this.code,
      // regionsValue: (this.regions === null || this.regions.length < 0) ? [] : this.regions,
      regionsValue: this.selectedRegionIds,
      phoneValue: this.phone,
      emailValue: this.email,
      websiteValue: this.website,
      afmNumberValue: this.afm_number,
      kifidNumberValue: this.kifid_number,
      excludedRollsProducts: this.excluded_rolls_products,
      customerPortalLinkValue: this.customer_portal_link,
      businessHours: 'holidays',
      timeout: null,
      loading: false,
      validPostalCode: true,
      test: true,
      editingRollsProducts: this.excluded_rolls_products ? this.excluded_rolls_products.length !== 0 : false
    }
  },
  computed: {
    hasSelectedProperty () {
      return this.selectedProperty !== null
    },
  },
  methods: {
    setSelectedRegions (value) {
      this.regionsValue = value
    },
    selectAllRollsProducts () {
      this.editingRollsProducts = false
      this.excludedRollsProducts = []
    }
  }
}
</script>

<style scoped>
.errors {
  color: #ff0000;
  font-style: italic;
}

.has-error {
  border-color: #f5222d;
}
</style>
